import { DEFAULT_CANVAS_NAME } from "@/api/canvas";
import { CanvasLinkAccessSection } from "@/components/ShareDialog/CanvasLinkAccessSection";
import { ShareDialog } from "@/components/ShareDialog/ShareDialog";
import { PERMISSIONS } from "@/constants/permissions";
import { useHasPermission } from "@/hooks/usePermissions";
import type { Canvas, SubjectObjectType } from "@cohesive/api-client";

export function ShareCanvasDialog({
  canvas,
  onClose,
}: {
  canvas: Canvas;
  onClose: () => void;
}) {
  const isOrgAdmin = useHasPermission(PERMISSIONS.ORG_ADMIN.ALL);
  const canvasName = canvas.name || DEFAULT_CANVAS_NAME;

  return (
    <ShareDialog
      resourceObjectType="canvas"
      resourceObjectId={canvas.id}
      subjectObjectType={[
        ...(isOrgAdmin ? (["organization"] as SubjectObjectType[]) : []),
        "organization_user" as SubjectObjectType,
        ...(isOrgAdmin ? (["group"] as SubjectObjectType[]) : []),
      ]}
      title={`Share "${canvasName}"`}
      open
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      linkAccess={<CanvasLinkAccessSection canvas={canvas} />}
    />
  );
}
